import { BigqueryQueryViewerApp } from "./main";
import { registerComponent } from "lib/components";

registerComponent({ BigqueryQueryViewerApp });
